import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

import Dialog from '~/components/Dialog';
import Button from '~/components/Button';

import Request from '~/providers/Request';
import CorporationPaymenetServiceRecord from '~/records/CorporationPaymenetServiceRecord';

import Form from './Form';

function New({ isOpen, id, handleClose, onSuccess }) {
  const [record, setRecord] = useState(new CorporationPaymenetServiceRecord());
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  async function onSubmit() {
    const data = record.toParams();

    data.data.attributes.corporation_id = id;

    setLoading(true);

    Request.post(
      '/admin/corporation/payment_services',
      data,
      {},
      { controller: 'corporationPaymentServices' }
    )
      .then(() => {
        setLoading(false);
        toast.success(t('action.save_success'));
        onSuccess();
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  useEffect(() => {
    setRecord(new CorporationPaymenetServiceRecord());
  }, [isOpen]);

  return (
    <Dialog
      icon={<MonetizationOnIcon />}
      isOpen={isOpen}
      handleClose={handleClose}
      title={t('corporation.tabs.financial')}
      fullScreen
      dialogActions={
        <>
          <Button disabled={loading} color="grey" onClick={handleClose}>
            {t('action.cancel')}
          </Button>
          <Button disabled={loading} color="green" onClick={onSubmit}>
            {t('action.save')}
          </Button>
        </>
      }
    >
      <>
        <Form record={record} handleChange={handleChange} loading={loading} />
      </>
    </Dialog>
  );
}

New.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

New.defaultProps = {
  isOpen: false,
};

export default New;
